import {
  ICatchARideAvailability,
  isNonEmptyArray,
  isValidTimeString,
} from "@ryde/shared";

import { catchARideAvailabilityListConditions } from "./catch-a-ride-availability.models";

/** A set with no condition at all would match every ride for every passenger, so it is not allowed. */
export const hasAnyCatchARideCondition = (
  item: Partial<ICatchARideAvailability> | undefined,
): boolean => {
  if (!item) {
    return false;
  }

  return (
    isValidTimeString(item.from) ||
    isValidTimeString(item.to) ||
    catchARideAvailabilityListConditions.some(condition =>
      isNonEmptyArray(item[condition.name]),
    )
  );
};

/** Drops empty lists and blank times so the stored JSON only carries the conditions the admin actually set. */
export const normalizeCatchARideAvailability = (
  item: Partial<ICatchARideAvailability>,
): ICatchARideAvailability => {
  const normalized: ICatchARideAvailability = {};

  if (isValidTimeString(item.from)) {
    normalized.from = item.from;
  }
  if (isValidTimeString(item.to)) {
    normalized.to = item.to;
  }
  for (const condition of catchARideAvailabilityListConditions) {
    const list = item[condition.name];
    if (!isNonEmptyArray(list)) {
      continue;
    }
    // The dropdown helper coerces numeric-looking option values to numbers; sectors are compared as strings server-side.
    const values = condition.isPlainTextValue
      ? (list as unknown[]).map(String)
      : list;
    Object.assign(normalized, { [condition.name]: values });
  }

  return normalized;
};

export const catchARideAvailabilitySerialized = (
  item: Partial<ICatchARideAvailability> | undefined,
): string => JSON.stringify(normalizeCatchARideAvailability(item ?? {}));
